import { RootState } from 'base/reducer/reducer';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { EntityPrefixEnum, getFormatedId } from 'utils/commonHelper';
import { ProjectResponse } from 'services/tenantManagementService';

export const useFormattedProjectOrCategoryValue = () => {
	const persistedProject = useSelector((state: RootState) => state.persistedProject);
	const persistedOrganizationalUnitManagerProject = useSelector((state: RootState) => state.persistedOrganizationalUnitManagerProject);
	const persistedTimeTravelNonProjectCategories = useSelector((state: RootState) => state.persistedTimeTravelNonProjectCategories);

	return useCallback(
		(id: number | undefined, isProjectConnected: boolean) => {
			if (!id) {
				return '';
			}

			if (isProjectConnected) {
				// Check both stores so resource managers see project name for org-unit projects they can see via team members
				const project: ProjectResponse | undefined = persistedProject.itemsMap[id] ?? persistedOrganizationalUnitManagerProject.itemsMap[id];
				return project
					? `${getFormatedId(EntityPrefixEnum.PROJECT, id)} - ${project.name}`
					: getFormatedId(EntityPrefixEnum.PROJECT, id);
			}

			return persistedTimeTravelNonProjectCategories.itemsMap[id]?.name || '';
		},
		[persistedProject.itemsMap, persistedOrganizationalUnitManagerProject.itemsMap, persistedTimeTravelNonProjectCategories.itemsMap]
	)
}
